export var AlertMarkup;
(function (AlertMarkup) {
    AlertMarkup["P"] = "p";
    AlertMarkup["H2"] = "h2";
    AlertMarkup["H3"] = "h3";
    AlertMarkup["H4"] = "h4";
    AlertMarkup["H5"] = "h5";
    AlertMarkup["H6"] = "h6";
})(AlertMarkup || (AlertMarkup = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQWxlcnRFbnVtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vY29tcG9uZW50cy9hbGVydC9BbGVydEVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxDQUFOLElBQVksV0FPWDtBQVBELFdBQVksV0FBVztJQUNyQixzQkFBTyxDQUFBO0lBQ1Asd0JBQVMsQ0FBQTtJQUNULHdCQUFTLENBQUE7SUFDVCx3QkFBUyxDQUFBO0lBQ1Qsd0JBQVMsQ0FBQTtJQUNULHdCQUFTLENBQUE7QUFDWCxDQUFDLEVBUFcsV0FBVyxLQUFYLFdBQVcsUUFPdEIifQ==